const tableStyles = {
  tableSmall: {
    cell: {
      padding: 5,
      fontSize: '0.7rem',
    },
  },
};

export default tableStyles;
